module.exports = __webpack_public_path__ + "img/hr-dead.fdbc0a80.png";